import React, { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import useGlobalTheme from '../../hooks/useGlobalTheme'

function ExtensionAuth({ token }) {
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [confirmed, setConfirmed] = useState(false)
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	useEffect(() => {
		if (token) {
			try {
				const decodedToken = jwtDecode(token)
				const currentTime = Date.now() / 1000

				if (decodedToken.exp && decodedToken.exp < currentTime) {
					console.log('Token is expired')
					handleLogout()
				} else {
					setEmail(decodedToken.email)
				}
			} catch (error) {
				console.error('Error decoding token:', error)
				handleLogout()
			}
		}
	}, [token])

	const handleConfirmation = () => {
		setConfirmed(true)
		window.opener.postMessage({ type: 'AUTH_SUCCESS', payload: { token } }, '*')
	}

	const handleLogout = () => {
		localStorage.removeItem('jwtToken')
		navigate('/login?from=extension')
	}

	return (
		<div className={`flex items-center justify-center min-h-screen ${isLight ? 'bg-white' : 'bg-[#15202b]'}`}>
			<div className={`w-full max-w-md p-8 rounded-lg shadow-xl ring-1 ${
				isLight
					? 'bg-white ring-gray-200 text-gray-900'
					: 'bg-gray-800 ring-white/10 text-white'
			}`}>
				<h2 className={`text-3xl font-bold mb-6 text-center ${isLight ? 'text-gray-900' : 'text-white'}`}>
					Login Confirmation
				</h2>
				{email && !confirmed && (
					<div className="mb-8 text-center">
						<p className={isLight ? 'text-gray-700' : 'text-gray-300'}>
							Do you want to log in with the account:
						</p>
						<p className={`text-lg font-semibold mt-2 ${isLight ? 'text-gray-900' : 'text-white'}`}>{email}</p>
					</div>
				)}
				{confirmed && (
					<div className="mb-8 text-center">
						<p className={`font-semibold ${isLight ? 'text-green-600' : 'text-green-400'}`}>
							You have successfully signed in.
						</p>
					</div>
				)}
				<div className="flex flex-col space-y-4">
					{email && !confirmed && (
						<button
							onClick={handleConfirmation}
							className={`w-full py-3 px-4 bg-[#1d9bf0] text-white font-semibold rounded-lg shadow-md hover:bg-[#1a8cd8] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-200 ease-in-out ${
								isLight ? 'focus:ring-offset-white' : 'focus:ring-offset-gray-800'
							}`}
						>
							Confirm Login
						</button>
					)}
					<button
						onClick={handleLogout}
						className={`w-full py-3 px-4 font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-200 ease-in-out ${
							isLight
								? 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-offset-white'
								: 'bg-gray-700 text-gray-200 hover:bg-gray-600 focus:ring-offset-gray-800'
						}`}
					>
						Use Different Account
					</button>
				</div>
			</div>
		</div>
	)
}

export default ExtensionAuth
